import React from "react";
import { Card } from "react-bootstrap";
import SidebarItem from "./item";



class Sidebar extends React.Component {
    onClick = (evt, index, key, properties) => {
        if (this.props.onClick) this.props.onClick(evt, index, key, properties);
    }
    
    render() {
        if (!this.props.items) return <></>;

        const items = this.props.items;
        return (
            <Card className="fera-section-browser">
            <div className="fera-section-browser__items">
                {items.map(({ key: sectionKey, ...item }) => (
                    <SidebarItem key={item.uuid || sectionKey || item.index} {...item} sectionKey={sectionKey} active={item.index === this.props.selectedIndex} onClick={ this.onClick } iconColor="black" />
                ))}
            </div></Card>
        );
    }
}

export default Sidebar;
